module.exports = __webpack_public_path__ + "img/polytron-logo.e5a5140a.png";